import type { CartSaved } from '@/types/manage.types';

export const cartHelpers = {
  calculateTotal: (items: CartSaved[]): number => {
    return items.reduce((total, item) => {
      const price = item.in_cart?.price || 0;
      const quantity = item.quantity || 1;
      return total + price * quantity;
    }, 0);
  },

  getItemCount: (items: CartSaved[]): number => {
    return items.reduce((count, item) => count + (item.quantity || 1), 0);
  },

  findItemByVariantId: (items: CartSaved[], variant_id: string): CartSaved | undefined => {
    return items.find((item) => item.variant_id === variant_id);
  },

  validateCartItems: (items: CartSaved[]): { isValid: boolean; errors: string[] } => {
    const errors: string[] = [];

    if (items.length === 0) {
      errors.push('Cart is empty');
    }

    items.forEach((item, index) => {
      if (!item.variant_id) {
        errors.push(`Item ${index + 1}: Variant ID is required`);
      }
      if (!item.quantity || item.quantity <= 0) {
        errors.push(`Item ${index + 1}: Valid quantity is required`);
      }
    });

    return {
      isValid: errors.length === 0,
      errors,
    };
  },
};
